import axios from 'axios';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import { ERROR_RETRY } from '../../../lib/Error';

export const doRefundPayment = async ({
  id,
  amount,
  reason,
  holder,
  account,
  bankCode,
}) => {
  try {
    const response = await axios.put(
      BABYFACE_URL.concat(`/order/${id}/refund`),
      {
        amount,
        reason,
        holder,
        account,
        bankCode,
      },
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
